import qs from 'qs'
import _ from 'lodash'

type Type = 'string' | 'boolean'

export function getVar(key: string, type: Type = 'string') {
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (_.has(query, key)) {
        const value = _.get(query, key)
        if (_.isNull(value) || _.isUndefined(value)) {
            return true
        }
        if (type === 'boolean') {
            if (_.lowerCase(value as string) === 'false') {
                return false
            } else {
                return true
            }
        }
        return value
    }
    return localStorage.getItem(key)
}
